import { Component, OnInit } from '@angular/core';
import { LetterService } from '../../shared/_services/letter.service';
import { LetterFeatures } from '../../shared/models/letterfeatures.model';
import { CARTAS } from '../../shared/mockups/letter.mockup';
import { AuthenticationService } from '../../shared/_services/authentication.service';
import { User } from '../../shared/models/user.model';

@Component({
  selector: 'app-generate-letter',
  templateUrl: './generate-letter.component.html',
  styleUrls: ['./generate-letter.component.css']
})
export class GenerateLetterComponent implements OnInit {

  letterFeatures: LetterFeatures;
  letterPackList: LetterFeatures[] = [];
  total: number;
  first: number;
  currentUser: User;
  error: string;

  constructor(private letterService: LetterService,
  private authenticationService: AuthenticationService
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
  }

  ngOnInit() {
  }

  get isAssistant() {
    return this.currentUser && this.currentUser.fkUserRole === 4;
  }

  getLetterFeatures() {
    this.letterService.getLetterFeatures()
      .subscribe(letterFeatures => {
        this.letterFeatures = letterFeatures
        this.calculateRanges(this.letterFeatures);
      });
    this.letterPackList.length = 0;
  }

  sendLetterPack(letterPack: LetterFeatures) {
    this.letterService.sendLetterPack(letterPack, 'cartas-' + letterPack.firstLetter + '-' + (letterPack.lastLetter)+'.pdf');
  }

  calculateRanges(letterFeatures) {
    let quantity = 300; // CAMBIAR MODELO PARA RECIBIR POR BASE DE DATOS

    if (letterFeatures) {
      let total = this.letterFeatures.totalLetters;

      let ranges = Math.floor(total / quantity);
      ranges = (total % quantity) == 0 ? ranges : ranges + 1; 
      console.log(ranges);

      let first = this.letterFeatures.firstLetter;

      for (let i = 0; i < ranges; i++) {
        let last = first + (quantity - 1);

        if (last > total) {
          let remains = total - first;
          last = first + remains;
          quantity = remains + 1;
        }

        this.letterPackList.push({
          'firstLetter' : first,
          'lastLetter' : last,
          'totalLetters' : last - (first - 1)
        });

        first = last + 1;

      }
      
    } else {
      //mensaje de error. No hay letterFeatures
    }

  }

  OneLetter(numberLetter: number) {
    this.letterService.sendLetter(numberLetter)
      .subscribe((blob: Blob) => {
        console.log('report is downloaded');
        this.createFile(blob, 'carta-' + numberLetter + '.pdf');
        this.error = "";
      },
      error => {
        if (error) {
          this.error = "Error al descargar carta individual. Verifique los datos ingresados.";
          this.cleanError();
        }
      });
  }

  secondThirdLetter(form) {
    let idDebtor = form.controls.idDebtorName.value;
    if (form.controls.radioButton.value == 'secondLetter') {
      this.letterService.downloadSecondLetter(idDebtor)
        .subscribe((blob: Blob) => {
          console.log('report is downloaded');
          this.createFile(blob, 'carta-' + idDebtor + '.pdf');
          this.error = "";
        },
        error => {
          if (error) {
            this.error = "Error al descargar Carta de Segundo Aviso";
            this.cleanError();
          }
        });
    } else if (form.controls.radioButton.value == 'thirdLetter') {
      this.letterService.downloadThirdLetter(idDebtor)
        .subscribe((blob: Blob) => {
          this.createFile(blob, 'carta-' + idDebtor + '.pdf');
          this.error = "";
        },
        error => {
          if (error) {
            this.error = "Error al descargar Carta de Tercer Aviso";
            this.cleanError();
          }
        });
    }
  }
  
  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }

  createFile(blob: Blob, filename: string) {
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, filename);
    }
    else {
      let link = document.createElement("a");
      if (link.download !== undefined) {
        let url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
      else {
        //html5 download not supported
      }
    }
  }

}
